var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_container"},[_c('div',{staticClass:"link_container"},[_c('label',{attrs:{"id":"link_label"}},[_vm._v("Open link")]),_c('a',{attrs:{"href":_vm.link,"id":"link_button","target":"_blank"}},[_vm._v("Open")])])])}
var staticRenderFns = []

export { render, staticRenderFns }